import { login } from '@/api/api'
import { 
  getToken, setToken, removeToken,
  getUserName, setUserName, removeUserName
 } from '@/utils/auth'

const state = {
  token: getToken(),
  username: getUserName(),
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USER_NAME: (state, username) => {
    state.username = username
  },
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { account, password } = userInfo
    return new Promise((resolve, reject) => {
      login({ account: account.trim(), password: password }).then(res => {
        if (res) {
          commit('SET_TOKEN', res['Login-Token'])
          commit('SET_USER_NAME', res.user_name)
          setToken(res['Login-Token'])
          setUserName(res.user_name)
          resolve()
        }else{
          reject(error)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      // logout(state.token).then(() => {
        commit('SET_TOKEN', '')
        commit('SET_USER_NAME', '')
        removeToken()
        removeUserName()

        resolve()
      // }).catch(error => {
      //   reject(error)
      // })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_USER_NAME', '')
      removeToken()
      removeUserName()
      resolve()
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
